import { BrowserRouter } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css'
import 'react-toastify/dist/ReactToastify.css';
import './App.css'
import AnimatedRoutes from './AnimatedRoutes';
// import AnimatedRoutes from 'AnimatedRoutes';
import { useEffect } from "react";
// import './messaging_init_in_sw';
function App() {
  // useEffect(() => {
  //   AOS.init();
  //   AOS.refresh();
  // }, []);
  return (
    <BrowserRouter>
      <AnimatedRoutes/>
    </BrowserRouter>
  );
}

export default App;
